import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class LeadDocketLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.LeadDocketSummaryLogSearchModel): Observable<Compliance.QueryResultModel<Core.LeadDocketSummaryLogModel>> {
        return this.httpPost('/api/diagnostics/leadDocket/summary', searchModel);
    }

    getDetail(searchModel: Core.LeadDocketDiagnosticsDetailSearchModel): Observable<Core.LeadDocketDiagnosticsDetailModel> {
        return this.httpPost('/api/diagnostics/leadDocket/detail', searchModel);
    }
}
